export function useObserverUntilReady(callback, options = {}, selectorOrNode) {
  if (typeof callback !== 'function') {
    throw new Error('useObserverUntilReady: callback must be a function');
  }
  const defaultOptions = { childList: true, subtree: true };

  const resolve = (v) => (typeof v === 'string' ? document.querySelector(v) : v);

  let target = resolve(selectorOrNode);
  const mainObserver = new MutationObserver((m, o) => callback(m, o));

  // Якщо вже є — одразу спостерігаємо за потрібним вузлом
  if (target instanceof Node) {
    mainObserver.observe(target, { ...defaultOptions, ...options });
    callback([], mainObserver);
    return { cleanup: () => mainObserver.disconnect(), observer: mainObserver };
  }

  // Інакше тимчасово дивимось на document.body і чекаємо появи
  const bootstrapObserver = new MutationObserver(() => {
    target = resolve(selectorOrNode);
    if (target instanceof Node) {
      // як тільки з’явився — підключаємось до нього
      mainObserver.observe(target, { ...defaultOptions, ...options });
      bootstrapObserver.disconnect();
      callback([], mainObserver);
    }
  });

  bootstrapObserver.observe(document.body, { childList: true, subtree: true });

  return {
    cleanup() {
      bootstrapObserver.disconnect();
      mainObserver.disconnect();
    },
    observer: mainObserver,
  };
}